(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5a37"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5a37"] = parcelRequire;
}
parcelRequire.register("hrfaN", function(module, exports) {
const modalOverlay = document.querySelector(".modal-overlay");
if (!modalOverlay) return;
function closeModal() {
    modalOverlay.classList.remove("modal-overlay-active");
}
// Close modal
modalOverlay.querySelector(".modal__close-button").onclick = closeModal;
modalOverlay.querySelector(".modal__button--decline").onclick = closeModal;
modalOverlay.onclick = closeModal;
// Prevent clicks inside the modal from closing it
modalOverlay.querySelector(".modal").onclick = function(event) {
    event.stopPropagation();
};
// Proceed to checkout
modalOverlay.querySelector(".modal__button--accept").addEventListener("click", function() {
    if (document.querySelector(".Form__CheckboxWrapper label") && document.querySelector(".Cart #cart_button_available .Cart__Checkout")) {
        document.querySelector(".Form__CheckboxWrapper label").click();
        document.querySelector(".Cart #cart_button_available .Cart__Checkout").click();
    }
});
const termsAndConditions = document.querySelector("from.Drawer__Content Link--underline");
if (termsAndConditions) termsAndConditions.addEventListener("click", function() {
    modalOverlay.classList.add("modal-overlay-active");
});

});

parcelRequire.register("3aBTb", function(module, exports) {
const searchModal = document.querySelector(".Search.Modal");
if (!searchModal) return;
const buttons = searchModal.querySelectorAll(".Search__Results-Tab button");
const objectTypeInput = searchModal.querySelector('input[name="type"]');
if (buttons.length > 0) buttons.forEach((button)=>{
    button.addEventListener("click", ()=>{
        searchModal.querySelectorAll(".Search__Results-Tab button").forEach((otherButton)=>{
            otherButton.classList.remove("active");
        });
        button.classList.add("active");
        searchModal.querySelectorAll("#predictive-search-results div").forEach((content)=>{
            content.classList.remove("active");
        });
        const SearchTypeElement = searchModal.querySelector("." + button.value);
        SearchTypeElement.classList.add("active");
        const activeObjectType = button.dataset.objectType;
        if (objectTypeInput && activeObjectType) objectTypeInput.value = activeObjectType;
    });
});

});

parcelRequire.register("e0H8f", function(module, exports) {
const orderPage = document.querySelector(".order__wrapper");
if (!orderPage) return;
const orderSection = orderPage.querySelector(".order__section");
if (!orderSection) return;
const orderOverview = orderPage.querySelector(".order__overview");
if (!orderOverview) return;
const orderMain = orderPage.querySelector(".order__main");
if (!orderMain) return;
if (orderPage) ordersInit();
function ordersInit() {
    const orders = orderPage.querySelectorAll(".Order_box_wrap");
    if (!orders) return;
    for (const order of orders){
        const orderLink = order.querySelector("a.Link");
        orderLink.addEventListener("click", (event)=>fetchOrder(event, order));
    }
}
async function fetchOrder(event, order) {
    event.preventDefault();
    const target = event.target;
    if (!target) return;
    const orderHref = target.getAttribute("href");
    if (!orderHref) return;
    if (orderMain) {
        if (orderMain.classList.contains("d-none")) orderMain.classList.remove("d-none");
    }
    try {
        const orderResponse = await fetch(orderHref);
        if (!orderResponse.ok) throw new Error(`HTTP error! Status: ${orderResponse.status}`);
        const contentType = orderResponse.headers.get("content-type");
        if (contentType && contentType.includes("text/html")) {
            const orderRaw = await orderResponse.text();
            const parser = new DOMParser();
            const orderHtml = parser.parseFromString(orderRaw, "text/html");
            const orderWrapper = orderHtml.querySelector("main#main .PageLayout");
            if (!orderWrapper) return;
            orderOverview.classList.add("d-none");
            if (orderMain) {
                orderMain.innerHTML = orderWrapper.innerHTML;
                renderShowOrdersSection(orderMain);
            }
        } else throw new Error(`Expected text/html but received: ${contentType}`);
    } catch (error) {
        console.warn("not good: error occured:", error);
    }
}
function renderShowOrdersSection(orderMain) {
    const showOrders = document.createElement("div");
    const showOrderPlaceholder = document.createElement("div");
    const showOrderIcon = document.createElement("div");
    showOrders.classList.add("show__orders", "d-none", "d-xl-flex", "text--small");
    showOrderPlaceholder.textContent = window.languages.show_orders_overview;
    const backSectionNavigation = document.querySelector(".back-section__wrapper");
    if (backSectionNavigation) {
        const backSectionNavigationIcon = backSectionNavigation.querySelector(".back-section__icon svg");
        if (backSectionNavigationIcon) {
            const backSectionNavigationIconClone = backSectionNavigationIcon.cloneNode(true);
            showOrderIcon.appendChild(backSectionNavigationIconClone);
            showOrders.appendChild(showOrderIcon);
        }
    }
    showOrders.appendChild(showOrderPlaceholder);
    orderMain.appendChild(showOrders);
    showOrders.addEventListener("click", ()=>returnToOrderOverview(orderMain));
    const orderButtons = orderMain.querySelectorAll("button.ProductForm__AddToCart");
    if (!orderButtons) return;
    [
        ...orderButtons
    ].forEach((orderButton)=>{
        orderButton.addEventListener("click", (event)=>addToCartOrder(event, orderMain));
    });
}
function returnToOrderOverview(orderMain) {
    if (!orderMain || !orderOverview) return;
    orderMain.classList.add("d-none");
    orderMain.innerHTML = "";
    orderOverview.classList.remove("d-none");
}
async function addToCartOrder(event, orderMain) {
    event.preventDefault();
    const tagetButton = event.target;
    if (tagetButton.tagName !== "BUTTON") return;
    const currentForm = tagetButton.closest("form");
    if (!currentForm) return;
    tagetButton.setAttribute("disabled", "disabled");
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    formData = new FormData(currentForm);
    try {
        const orderResponse = await fetch("/cart/add.js", {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest"
            },
            body: formData
        });
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        if (orderResponse.ok) tagetButton.dispatchEvent(new CustomEvent("product:added", {
            bubbles: true,
            detail: {
                variant: currentForm.querySelector('[name="id"]').value,
                quantity: parseInt(currentForm.querySelector('[name="quantity"]') ? currentForm.querySelector('[name="quantity"]').value : currentForm.querySelector('[name="items[0][quantity]"]').value)
            }
        }));
        else if (orderResponse.status === 422) {
            const responseMessage = await orderResponse.json();
            alert(responseMessage.message);
        }
    } catch (err) {
        console.warn("error occured during add-to-cart process");
    }
}

});

$(document).ready(function() {
    $(".customreview-slider").slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        draggable: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});


var $b939826e1cdc8e05$export$e758ae0a3ed6423a = false; //initiate as false
function $b939826e1cdc8e05$export$d0a8044dce8ff2fc() {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        $b939826e1cdc8e05$export$e758ae0a3ed6423a = true;
        return $b939826e1cdc8e05$export$e758ae0a3ed6423a;
    }
}
//INIT 
$b939826e1cdc8e05$export$d0a8044dce8ff2fc();
window.addEventListener("resize", function() {
    $b939826e1cdc8e05$export$d0a8044dce8ff2fc();
});


var $46d17e806c82d883$var$wrapper = $(".Product__Gallery");
var $46d17e806c82d883$var$video = $46d17e806c82d883$var$wrapper.find(".product-video__media");
// Taking all the product-video__media
$46d17e806c82d883$var$video.each(function(i, e) {
    // remove the img in native video to prevent query from the photoswipe function to access the wrong img element
    $(e).find("img").remove();
    // hide the img if the media is video so the video in the background can show
    if ($(".Product__Slideshow").find($(e)).length == 1) $(e).next().addClass("no-show");
});


var $a3e03eb3ff058089$var$slidesToShow = $(".testimonials-slider").data("slides-to-show") || 2;
$(".testimonials-slider").slick({
    infinite: true,
    slidesToShow: $a3e03eb3ff058089$var$slidesToShow,
    slidesToScroll: 1,
    dots: false,
    prevArrow: `
  <button type="button" class="slick-prev slick-arrow">
    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="#3f464b">
    </svg>
  </button>`,
    nextArrow: `
  <button type="button" class="slick-next slick-arrow">
    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="#3f464b">
    </svg>
  </button>`,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false
            }
        }
    ]
});


window.addEventListener("load", ()=>{
    const klaviyoBISOpenTrigger = document.querySelector(".klaviyo-bis-trigger");
    if (!klaviyoBISOpenTrigger) return;
    klaviyoBISOpenTrigger.addEventListener("click", modalBackInStockInit);
    function modalBackInStockInit() {
        const targetNode = document.getElementById("klaviyo-bis-iframe");
        const config = {
            attributes: true,
            childList: true,
            subtree: true
        };
        const callback = (mutationList, observer)=>{
            for (const mutation of mutationList)if (mutation.type === "attributes") modalBackInStockIsLoaded();
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
        function modalBackInStockIsLoaded() {
            const klaviyoIframeEl = document.querySelector("iframe#klaviyo-bis-iframe");
            const klaviyoIframe = klaviyoIframeEl.contentDocument;
            const submitBIS = klaviyoIframe.querySelector(".submit-container");
            const emailInput = klaviyoIframe?.querySelector("#email");
            const errorMessageEmail = klaviyoIframe?.querySelector("#error_message");
            if (klaviyoIframeEl.style.display == "") document.querySelector("body").style.overflow = "hidden";
            else document.querySelector("body").style.overflow = "auto";
            const emailWrapper = emailInput.closest(".col-sm-12");
            emailWrapper.append(errorMessageEmail);
            if (!errorMessageEmail || !submitBIS || !emailInput || !errorMessageEmail) return;
            errorMessageEmail.innerText = "";
            errorMessageEmail.innerText = window.languages.error_message_klaviyo;
            function emailValidator(email) {
                const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return re.test(email);
            }
            emailInput?.addEventListener("input", (e)=>handleEmailValidation(e));
            submitBIS.addEventListener("click", (e)=>handleEmailValidation(e));
            function handleEmailValidation(e) {
                const isEmailValid = emailValidator(emailInput.value);
                if (!isEmailValid) {
                    e.preventDefault();
                    emailInput.style.borderColor = "red";
                    errorMessageEmail.style.display = "block";
                } else {
                    emailInput.style.borderColor = "#294634";
                    errorMessageEmail.style.display = "none";
                }
            }
        }
    }
});


parcelRequire("hrfaN");
class $e4142d9d750ed2f1$export$9f3d1377f61d5537 {
    constructor(el){
        this.sidebarMenu = el;
        this.sideBarMenuFirst = this.sidebarMenu?.querySelector(".SidebarMenu__Nav[first-level]");
        this.headersideBarButtonIcon = document.querySelector(".Header__Icon");
        if (this.sidebarMenu) this.setupEvents();
    }
    setupEvents() {
        this.headersideBarButtonIcon?.addEventListener("click", ()=>{
            document.querySelectorAll(".adjusted-height__from-current-section").forEach((el)=>{
                el.style.height = "";
            });
        });
        this.sidebarMenu.querySelectorAll(".Collapsible a").forEach((item)=>{
            item.addEventListener("click", (e)=>this.handleHistory(e, item));
        });
        this.sidebarMenu.querySelectorAll("[data-action='open-level-2']").forEach((item)=>{
            item.addEventListener("click", (e)=>this.openLevel(e, item, 2));
        });
        this.sidebarMenu.querySelectorAll("[data-action='open-level-3']").forEach((item)=>{
            item.addEventListener("click", (e)=>this.openLevel(e, item, 3));
        });
        this.sidebarMenu.querySelectorAll('[data-action="back"]').forEach((item)=>{
            item.addEventListener("click", (e)=>this.goBack(e, item));
        });
    }
    openSidebar() {
        this.headersideBarButtonIcon.click();
    }
    handleHistory(e, item) {
        e.preventDefault();
        const level = item.closest("[data-level]");
        const levelNumber = parseInt(level.getAttribute("data-level"), 10);
        history.pushState({
            sidebarLevel: levelNumber,
            item: item.getAttribute("local-id")
        }, "", item.getAttribute("href"));
        setTimeout(()=>{
            window.location.href = `${item.getAttribute("href")}`;
        }, 200);
    }
    openLevel(e, item, level, redirected = false) {
        e.preventDefault();
        let parent;
        let levelEl;
        if (!redirected) {
            parent = item.parentElement;
            levelEl = parent.querySelector(`[data-level='${level}']`);
            levelEl.setAttribute("aria-hidden", levelEl.getAttribute("aria-hidden") === "true" ? "false" : "true");
        } else {
            if (level === 3) {
                parent = item.closest(".SidebarMenu__Nav").closest(".Collapsible");
                levelEl = parent.querySelector(`[data-level='${level}']`);
                levelEl.setAttribute("aria-hidden", levelEl.getAttribute("aria-hidden") === "true" ? "false" : "true");
                const newLevelEl = levelEl.closest(".Collapsible").closest("section.SidebarMenu.Drawer[aria-hidden]");
                newLevelEl.setAttribute("aria-hidden", newLevelEl.getAttribute("aria-hidden") === "true" ? "false" : "true");
            } else if (level == 2) {
                parent = item.closest(".SidebarMenu__Nav").closest(".Collapsible");
                levelEl = parent.querySelector(`[data-level='${level}']`);
                levelEl.setAttribute("aria-hidden", levelEl.getAttribute("aria-hidden") === "true" ? "false" : "true");
            }
        }
        if (!levelEl || levelEl === null) levelEl = parent;
        setTimeout(()=>{
            this.adjustHeightOfSidebarSections(item, levelEl);
        }, 0);
        if (level === 3) {
            const level2 = parent.closest("[data-level='2']");
            const nav = levelEl.querySelector(".SidebarMenu__Nav--primary");
            const drawerMain = level2.querySelector(".Drawer__Main");
            if (nav.offsetHeight < 700) {
                drawerMain.style.overflowY = "hidden";
                drawerMain.scrollTo(0, 0);
            } else drawerMain.style.overflowY = "auto";
        }
    }
    goBack(e, item) {
        e.preventDefault();
        const parent = item.parentElement;
        const level = parent.closest("[data-level]");
        const previousLevel = level.previousElementSibling;
        level.setAttribute("aria-hidden", "true");
        previousLevel.closest(".Drawer__Main").style.overflowY = "auto";
        previousLevel.setAttribute("aria-hidden", "false");
        setTimeout(()=>{
            const previousLevelButton = previousLevel?.closest(".Collapsible")?.closest(".Drawer__Main")?.closest(".Collapsible")?.querySelector(".Collapsible__Button");
            this.adjustHeightOfSidebarSections(previousLevelButton);
        }, 0);
    }
    adjustHeightOfSidebarSections(wrapper, sectionOverride = null) {
        document.querySelectorAll(".adjusted-height__from-current-section").forEach((el)=>{
            el.style.height = "";
        });
        const currSection = sectionOverride || wrapper?.closest(".Collapsible")?.querySelector("section.SidebarMenu");
        const currSideBarMenu = currSection?.querySelector(".Drawer__Container .SidebarMenu__Nav");
        let currSideBarMenuHeight = currSideBarMenu?.offsetHeight || 0;
        const visibleClientHeight = window.innerHeight || document.documentElement.clientHeight;
        const isMenuBiggerThanScreen = currSideBarMenuHeight + 120 > visibleClientHeight;
        if (isMenuBiggerThanScreen) {
            document.querySelectorAll("section.SidebarMenu.Drawer").forEach((el)=>{
                el.style.height = `calc(${currSideBarMenuHeight}px + 120px)`;
                el.classList.add("adjusted-height__from-current-section");
            });
            this.sideBarMenuFirst.style.height = `calc(${currSideBarMenuHeight}px)`;
            this.sideBarMenuFirst.classList.add("adjusted-height__from-current-section");
        }
    }
}
const $e4142d9d750ed2f1$var$sideBarMenu = document.querySelector("#sidebar-menu");
let $e4142d9d750ed2f1$var$sideBarMenuHandlerInstance = null;
if ($e4142d9d750ed2f1$var$sideBarMenu) $e4142d9d750ed2f1$var$sideBarMenuHandlerInstance = new $e4142d9d750ed2f1$export$9f3d1377f61d5537($e4142d9d750ed2f1$var$sideBarMenu);
if (window.innerWidth <= 768) {
    let handled = false;
    const activeNavigationItemId = history.state?.item;
    const sidebarLevel = history.state?.sidebarLevel;
    window.addEventListener("popstate", function(e) {
        if (sidebarLevel && sidebarLevel && !handled) {
            handled = true;
            $e4142d9d750ed2f1$var$openSidebarAtLevel(sidebarLevel, activeNavigationItemId, e);
            history.pushState({
                sidebarLevel: sidebarLevel ? sidebarLevel : 3,
                item: activeNavigationItemId ? activeNavigationItemId : ""
            }, "", window.location.href);
            setTimeout(()=>handled = false, 500);
        }
    });
}
function $e4142d9d750ed2f1$var$openSidebarAtLevel(level, activeNavigationItemId, event) {
    event.preventDefault();
    const itemAttribute = `[local-id="${activeNavigationItemId}"]`;
    const item = document.querySelector(itemAttribute);
    $e4142d9d750ed2f1$var$sideBarMenuHandlerInstance.openSidebar();
    if (level === 2 || level === 3) $e4142d9d750ed2f1$var$sideBarMenuHandlerInstance.openLevel(event, item, level, true);
}


class $c959eabd22a30bff$var$PredictiveSearch extends HTMLElement {
    constructor(){
        super();
        this.input = this.querySelector('input[type="search"]');
        this.inputClear = this.querySelector("#clear-search");
        this.predictiveSearchResults = this.querySelector("#predictive-search");
        this.popularSearches = this.querySelector("#popular-searches");
        this.popularSearchesItems = this.querySelectorAll(".PopularSearches__Content .PopularSearches__Item");
        this.searchResultsTab = this.querySelector(".Search__Results-Tab");
        this.searchInputSuggestionText = this.querySelector("#predictive-search-suggestion-input");
        this.inputClear.addEventListener("click", ()=>{
            this.input.value = "";
            this.inputClear.classList.add("hidden");
            this.searchInputSuggestionText.textContent = "";
            this.input.focus();
            this.onChange();
        });
        this.popularSearchesItems.forEach((item)=>{
            item.addEventListener("click", ()=>{
                this.input.value = item.textContent.trim();
                this.onChange();
            });
        });
        this.input.addEventListener("keydown", (ev)=>{
            this.searchInputSuggestionText.textContent = "";
            this.searchInputSuggestionText.classList.add("hidden");
            if (ev.key === "Enter" && this.querySelector("#predictive-search-suggestion").textContent.length) {
                this.input.value = this.querySelector("#predictive-search-suggestion").textContent;
                this.onChange();
            }
        });
        this.input.addEventListener("input", ()=>{
            this.adjustSuggestionPosition.call(this);
        });
        this.input.addEventListener("input", this.debounce((event)=>{
            this.onChange(event);
        }, 300).bind(this));
        if (this.input.value.length) this.input.addEventListener("focus", this.debounce((event)=>{
            this.onChange(event);
        }, 300).bind(this));
    }
    adjustSuggestionPosition() {
        const tempElement = document.createElement("span");
        tempElement.style.fontSize = "18px";
        tempElement.style.visibility = "hidden";
        tempElement.style.whiteSpace = "nowrap";
        tempElement.textContent = this.input.value;
        document.body.appendChild(tempElement);
        const inputWidth = tempElement.offsetWidth;
        this.searchInputSuggestionText.style.left = `${inputWidth + 50}px`;
        document.body.removeChild(tempElement);
    }
    onChange() {
        const searchTerm = this.input.value.trim();
        if (!searchTerm.length) {
            this.close();
            this.inputClear.classList.add("hidden");
            this.popularSearches.classList.remove("hidden");
            this.searchResultsTab.classList.add("hidden");
            return;
        } else {
            this.inputClear.classList.remove("hidden");
            this.popularSearches.classList.add("hidden");
            this.searchResultsTab.classList.remove("hidden");
        }
        this.querySelectorAll(".Search__Results-Tab button").forEach((otherButton)=>{
            otherButton.classList.remove("active");
        });
        this.querySelectorAll(".Search__Results-Tab button")[0].classList.add("active");
        const objectTypeInput = this.querySelector('input[name="type"]');
        const activeObjectType = this.querySelectorAll(".Search__Results-Tab button")[0]?.dataset.objectType;
        if (objectTypeInput && activeObjectType) objectTypeInput.value = activeObjectType;
        this.getSearchResults(searchTerm);
    }
    getSearchResults(searchTerm) {
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=query,product,collection,page,article`).then((response)=>{
            if (!response.ok) {
                const error = new Error(response.status);
                this.close();
                throw error;
            }
            return response.text();
        }).then((text)=>{
            const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            const bestsellersSlider = this.querySelector(".bestsellers-slider");
            if (bestsellersSlider) $(bestsellersSlider).slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            });
            const suggestionText = this.querySelector("#predictive-search-suggestion").textContent;
            let commonPrefix = "";
            for(let i = 0; i < searchTerm.length && i < suggestionText.length; i++){
                if (searchTerm[i] === suggestionText[i]) commonPrefix += searchTerm[i];
                else break;
            }
            // Replace the common prefix with spaces
            let modifiedSuggestionText = suggestionText.replace(new RegExp(`^${commonPrefix}`, "g"), commonPrefix.replace(/./g, " "));
            this.searchInputSuggestionText.textContent = modifiedSuggestionText;
            if (searchTerm.length) this.searchInputSuggestionText.classList.remove("hidden");
            this.querySelectorAll("#predictive-search-results-queries-list li").forEach((suggestion)=>{
                suggestion.addEventListener("click", ()=>{
                    this.input.value = suggestion.textContent.trim();
                    this.onChange();
                });
            });
            this.open();
        }).catch((error)=>{
            this.close();
            throw error;
        });
    }
    open() {
        this.predictiveSearchResults.style.display = "block";
    }
    close() {
        this.predictiveSearchResults.style.display = "none";
    }
    debounce(fn, wait) {
        let t;
        return (...args)=>{
            clearTimeout(t);
            t = setTimeout(()=>fn.apply(this, args), wait);
        };
    }
}
customElements.define("predictive-search", $c959eabd22a30bff$var$PredictiveSearch);


parcelRequire("3aBTb");
class $ded3ce67e75af81b$var$shippingProgressbar {
    constructor(shippingProgressbarEl){
        this.currentElement = shippingProgressbarEl;
        if (!this.currentElement) return;
        this.threshold = this.currentElement.dataset.threshold;
        this.freeShipping = this.currentElement.dataset.freeShipping;
        this.init();
    }
    async init() {
        this.onCartAction();
    }
    async onCartAction() {
        window.addEventListener("rendered-cart", ()=>{
            setTimeout(async ()=>{
                try {
                    const cart = await fetch(window.Shopify.routes.root + "cart.js", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                    const cartData = await cart.json();
                    this.shippingCalculator(cartData);
                } catch (e) {
                    console.warn("error:", e);
                }
            }, 100);
        });
    }
    shippingCalculator(cartData) {
        const cartItemsPrice = parseFloat(cartData.items_subtotal_price);
        const thresholdNumber = parseFloat(this.threshold);
        let differenceAmount = 0;
        const difference = cartItemsPrice / thresholdNumber;
        let differencePercentage = difference * 100;
        if (differencePercentage >= 100) {
            differencePercentage = 100;
            this.freeShipping = true;
        } else {
            differencePercentage = differencePercentage.toFixed(2);
            this.freeShipping = false;
            differenceAmount = (thresholdNumber - cartItemsPrice) / 100;
            const differenceAmountEl = document.querySelector(".free-shipping-un__text-block span[free-shipping-difference]");
            differenceAmountEl.innerText = differenceAmount;
        }
        const sidebarCart = document.querySelector("#sidebar-cart");
        if (!sidebarCart) return;
        this.currentElement.setAttribute("data-free-shipping", this.freeShipping);
        sidebarCart.style.setProperty("--progress_difference", differencePercentage + "%");
    }
}
const $ded3ce67e75af81b$var$shippingProgressbarEl = document.querySelector("shipping-progressbar");
if ($ded3ce67e75af81b$var$shippingProgressbarEl) new $ded3ce67e75af81b$var$shippingProgressbar($ded3ce67e75af81b$var$shippingProgressbarEl);


class $67df1c0557076c04$var$Drawer {
    constructor(drawerEl){
        this.currentElement = drawerEl;
        this.cart_info_login_toggle = document.getElementById("cart-info-login-toggle");
        this.loginForm = document.getElementById("cart-info-login");
        this.formTermsLink = this.currentElement.querySelector('.Form__CheckboxWrapper label[for="terms"] a');
        this.lastWidth = window.innerWidth;
        this.loginStatus = drawerEl.getAttribute("is-user-logged-in");
        this.cartEls = {
            drawerHeader: drawerEl.querySelector(".Drawer__Header"),
            drawerFooter: drawerEl.querySelector(".Drawer__Footer")
        };
        if (this.formTermsLink) this.formTermsLink.addEventListener("click", this.activateFormTermsLinkModal);
        this.init();
        const _this = this;
        window.addEventListener("rendered-cart", function() {
            setTimeout(()=>{
                _this.formTermsLink = drawerEl.querySelector('.Form__CheckboxWrapper label[for="terms"] a');
                _this.formTermsLink.addEventListener("click", _this.activateFormTermsLinkModal);
            }, 1000);
        });
    }
    init() {
        if (this.loginStatus == "false" && document.querySelector(".Cart__Klub")) this.forgotYourPasswordLogic($67df1c0557076c04$var$drawerEl);
        setTimeout(()=>{
            this.handleResize();
        }, 2000);
        const debouncedCheckResize = this.debounce(this.checkResize.bind(this), 200);
        window.addEventListener("resize", debouncedCheckResize);
        this.onCartAction();
    }
    async onCartAction() {
        const outerThis = this;
        window.addEventListener("rendered-cart", ()=>{
            setTimeout(async ()=>{
                outerThis.handleResize();
            }, 1000);
        });
    }
    forgotYourPasswordLogic(drawerEl) {
        const customerLoginForm = drawerEl.querySelector(".Cart__Klub #customer_login");
        const recoverPasswordForm = drawerEl.querySelector(".Cart__Klub #recover_customer_password");
        if (!customerLoginForm || !recoverPasswordForm) return;
        const toggleRecoverForm = drawerEl.querySelectorAll('[data-action="toggle-recover-form"]');
        if (!toggleRecoverForm) return;
        toggleRecoverForm.forEach((el)=>el.addEventListener("click", function(ev) {
                customerLoginForm.classList.toggle("d-none");
                recoverPasswordForm.classList.toggle("d-none");
            }));
    }
    checkResize() {
        const currentWidth = window.innerWidth;
        if (Math.abs(currentWidth - this.lastWidth) >= 10) {
            this.lastWidth = currentWidth;
            this.handleResize();
        }
    }
    handleResize() {
        let viewportHeight = 0;
        viewportHeight = window.visualViewport.height;
        if (!this.cartEls.drawerHeader || !this.cartEls.drawerFooter) return;
        const drawerFooterHeight = $67df1c0557076c04$var$drawerEl.querySelector(".Drawer__Footer").offsetHeight;
        if (isNaN(drawerFooterHeight) || drawerFooterHeight === null) return;
        const drawerHeaderHeight = $67df1c0557076c04$var$drawerEl.querySelector(".Drawer__Header").offsetHeight;
        if (isNaN(drawerHeaderHeight) || drawerHeaderHeight === null) return;
        let heightFromAdditionalElement = 0;
        if (this.loginStatus === "false") {
            const cartKlub = document.querySelector(".Cart__Klub");
            if (cartKlub) {
                heightFromAdditionalElement = cartKlub.offsetHeight;
                if (isNaN(heightFromAdditionalElement) || heightFromAdditionalElement === null) return;
            }
        }
        const drawerContent = document.querySelector(`#sidebar-cart[is-user-logged-in=${this.loginStatus}] .Drawer__Main .Drawer__Container`);
        if (!drawerContent) return;
        let drawerSpace = 0;
        drawerSpace = drawerHeaderHeight + drawerFooterHeight + heightFromAdditionalElement;
        const extraSpacing = "10px";
        drawerContent.setAttribute("style", `max-height: calc(${viewportHeight}px - ${drawerSpace}px - ${extraSpacing});`);
    }
    debounce(func, delay) {
        let timeoutId;
        return function(...args) {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                func.apply(this, args);
            }, delay);
        };
    }
    activateFormTermsLinkModal(event) {
        event.preventDefault();
        document.querySelector(".checkout-confirmation-modal.modal-overlay").classList.add("modal-overlay-active");
    }
}
const $67df1c0557076c04$var$drawerEl = document.querySelector("#sidebar-cart");
if ($67df1c0557076c04$var$drawerEl) new $67df1c0557076c04$var$Drawer($67df1c0557076c04$var$drawerEl);


const $b2851f948f5594b4$var$discountCode = localStorage.getItem("klub-discount-code");
if (document.querySelector("#sidebar-cart") && localStorage.getItem("klub-discount-code")) {
    $b2851f948f5594b4$export$e32977758679607a($b2851f948f5594b4$var$discountCode);
    window.addEventListener("rendered-cart", ()=>{
        setTimeout(async ()=>{
            $b2851f948f5594b4$export$e32977758679607a($b2851f948f5594b4$var$discountCode);
        }, 1000);
    });
}
function $b2851f948f5594b4$export$e32977758679607a(discountCode) {
    const sidebar = document.querySelector("#sidebar-cart");
    const discountInput = sidebar.querySelector(".js-form-discount");
    if (!discountInput) return;
    const originalDiscountCode = discountInput.getAttribute("original-discount-value");
    if (originalDiscountCode) discountInput.setAttribute("value", `${originalDiscountCode},${discountCode}`);
    else discountInput.setAttribute("value", `${discountCode}`);
}



class $badd1c89a3cc93f3$var$Accounts {
    constructor(wrapperEl){
        if (!window.theme.customerLoggedIn) return;
        this.wrapperEl = wrapperEl;
        this.init();
    }
    async init() {
        this.wrapperEl.classList.add("loading");
        this.addLoadingSkeleton();
        await this.fetchprofile(window.theme.customerEmail);
        this.wrapperEl.classList.remove("loading");
        if (!this.customerData) {
            const smallBoxes = this.wrapperEl.querySelectorAll(".karmameju_box--small");
            smallBoxes.forEach((box)=>{
                box.remove();
            });
        } else {
            this.iconCopy = window.theme.icons.copy || "";
            this.toggleWelcomeMessage();
            this.toggleBirthdayMessage();
            this.toggleKKMessage();
            this.initEventForCustomerCode();
            this.determineUserDiscountCodeStatus();
        }
    }
    initEventForCustomerCode() {
        const outerThis = this;
        const boxesWithCode = document.querySelectorAll(".karmameju_box--small");
        if (!boxesWithCode) return;
        boxesWithCode.forEach((boxWithCode)=>{
            boxWithCode.addEventListener("click", function() {
                if (boxWithCode.hasAttribute("is-copied")) return;
                const iconWrapper = boxWithCode.querySelector(".icon__wrapper");
                const checkMarkIcon = document.querySelector(".checkmark__wrapper .Icon.Icon--checkmark")?.cloneNode(true);
                const currentDiscountCode = boxWithCode.querySelector("#DiscountCode");
                if (!checkMarkIcon || !currentDiscountCode || !iconWrapper) return;
                outerThis.copyToClipboard(currentDiscountCode.innerText);
                const iconCheckmarkWrapper = iconWrapper.querySelector(".icon-checkmark__wrapper");
                if (!iconCheckmarkWrapper) return;
                outerThis.activateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon);
            });
        });
    }
    activateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon) {
        iconCheckmarkWrapper.innerHTML = "";
        iconCheckmarkWrapper.insertAdjacentHTML("beforeend", `<span>${window.languages.code_copied_to_clipboard}</span>`);
        iconCheckmarkWrapper.appendChild(checkMarkIcon);
        boxWithCode.setAttribute("is-copied", "");
        iconWrapper.querySelector(".Icon.Icon--copy")?.classList.add("d-none");
        setTimeout(()=>{
            this.deactivateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon);
        }, 10000);
    }
    deactivateBoxWithCode(boxWithCode, iconWrapper, iconCheckmarkWrapper, checkMarkIcon) {
        boxWithCode.removeAttribute("is-copied");
        iconWrapper.querySelector(".Icon.Icon--copy")?.classList.remove("d-none");
        iconCheckmarkWrapper.innerHTML = "";
    }
    copyToClipboard(copyText) {
        navigator.clipboard.writeText(copyText);
        localStorage.setItem("klub-discount-code", copyText);
        (0, $b2851f948f5594b4$export$e32977758679607a)(copyText);
    }
    addLoadingSkeleton() {
        this.welcomeGiftEl = this.wrapperEl.querySelector("[data-welcome-gift]");
        if (this.welcomeGiftEl) this.welcomeGiftTextContent = this.welcomeGiftEl.querySelector("[data-text-content]");
        const welcomeGiftSkeleton = document.createElement("div");
        welcomeGiftSkeleton.classList.add("skeleton");
        this.welcomeGiftEl.appendChild(welcomeGiftSkeleton);
        this.birthdayGiftEls = this.wrapperEl.querySelectorAll("[data-birthday-gift]");
        if (this.birthdayGiftEls.length > 0) this.birthdayGiftEls.forEach((birthdayGiftEl)=>{
            this.birthdayGiftTextContent = birthdayGiftEl.querySelector("[data-text-content]");
            birthdayGiftEl.appendChild(welcomeGiftSkeleton.cloneNode(true));
        });
        this.kkGiftEls = this.wrapperEl.querySelectorAll("[data-kk-gift]");
        this.kkGiftEls.forEach((kkGiftEl)=>{
            kkGiftEl.appendChild(welcomeGiftSkeleton.cloneNode(true));
        });
    }
    async fetchprofile(email) {
        if (email) {
            const response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/getProfile?store=karmameju-klaviyo&email=${email}`);
            const data = await response.json();
            if (data.length > 0) this.customerData = data[0];
        }
    }
    toggleWelcomeMessage() {
        if (this.welcomeGiftTextContent) {
            const welcomeGiftRedeemed = this.customerData.attributes.properties.KK_velkomstgave_indløst;
            if (welcomeGiftRedeemed) this.welcomeGiftEl.remove();
            else {
                const welcomeGiftValue = this.welcomeGiftTextContent.dataset.textContent;
                if (welcomeGiftValue && window.languages.welcome_gift_not_redeemed) {
                    this.iconClipBuilder(this.welcomeGiftEl);
                    this.welcomeGiftTextContent.innerHTML = window.languages.welcome_gift_not_redeemed + '<span id="DiscountCode">' + welcomeGiftValue + "</span>";
                } else this.welcomeGiftEl.remove();
            }
        } else this.welcomeGiftEl.remove();
    }
    toggleBirthdayMessage() {
        this.birthdayGiftEls.forEach((birthdayGiftEl)=>{
            const birthdayGiftTextContent = birthdayGiftEl.querySelector("[data-text-content]");
            const birthdayGiftProperty = birthdayGiftEl.dataset.birthdayGift;
            if (birthdayGiftTextContent) {
                const birthdayGiftValue = birthdayGiftTextContent.dataset.textContent;
                const birthdayGiftPropertyValue = this.customerData.attributes.properties[birthdayGiftProperty];
                if (birthdayGiftPropertyValue && window.languages.birthday_gift_not_redeemed && birthdayGiftValue) {
                    this.iconClipBuilder(birthdayGiftEl);
                    birthdayGiftTextContent.innerHTML = window.languages.birthday_gift_not_redeemed + '<span id="DiscountCode">' + birthdayGiftValue + "</span>";
                } else birthdayGiftEl.remove();
            } else birthdayGiftEl.remove();
        });
    }
    iconClipBuilder(currentWrapper) {
        const iconWrapper = document.createElement("div");
        const iconCheckmarkWrapper = document.createElement("div");
        iconCheckmarkWrapper.classList.add("icon-checkmark__wrapper");
        iconWrapper.classList.add("icon__wrapper");
        iconWrapper.setAttribute("copy-code-to-clipboard", "");
        iconWrapper.innerHTML = this.iconCopy;
        iconWrapper.prepend(iconCheckmarkWrapper);
        const boxGrid = currentWrapper.querySelector(".karmameju_box_grid");
        if (!boxGrid) return;
        boxGrid.appendChild(iconWrapper);
        const skeleton = currentWrapper.querySelector(".skeleton");
        if (!skeleton) return;
        skeleton.classList.add("d-none");
    }
    toggleKKMessage() {
        this.kkGiftEls.forEach((kkGiftEl)=>{
            const kkGiftTextContent = kkGiftEl.querySelector("[data-text-content]");
            const kkGiftProperty = kkGiftEl.dataset.kkGift;
            if (kkGiftTextContent) {
                const kkGiftValue = kkGiftTextContent.dataset.textContent;
                const kkGiftPropertyValue = this.customerData.attributes.properties[kkGiftProperty];
                if (kkGiftPropertyValue && window.languages.kk_gift_not_redeemed && kkGiftValue) {
                    this.iconClipBuilder(kkGiftEl);
                    kkGiftTextContent.innerHTML = window.languages.kk_gift_not_redeemed + '<span id="DiscountCode">' + kkGiftValue + "</span>";
                } else kkGiftEl.remove();
            }
        });
    }
    determineUserDiscountCodeStatus() {
        const smallBoxes = this.wrapperEl.querySelectorAll(".karmameju_box--small");
        if (smallBoxes.length === 1) {
            if (!smallBoxes[0]) return;
            smallBoxes[0].classList.remove("d-none");
            document.querySelector(".karmameju_boxes__info--no-benefits").classList.remove("d-none");
        } else document.querySelector(".karmameju_boxes__info--with-benefits ").classList.remove("d-none");
    }
}
const $badd1c89a3cc93f3$var$kkBoxes = document.getElementById("karmameju_boxes");
if ($badd1c89a3cc93f3$var$kkBoxes) new $badd1c89a3cc93f3$var$Accounts($badd1c89a3cc93f3$var$kkBoxes);


parcelRequire("e0H8f");
const $058373812b4fba5d$var$sideBar = document.querySelector(".klub-page .klub-sidebar");
const $058373812b4fba5d$var$pageLayoutMain = document.querySelector(".PageLayout__main-page--klub");
let $058373812b4fba5d$var$screenWidth = window.innerWidth;
if ($058373812b4fba5d$var$sideBar && $058373812b4fba5d$var$screenWidth < 1300) $058373812b4fba5d$var$mobileSidebar();
function $058373812b4fba5d$var$mobileSidebar() {
    const urlParams = new URLSearchParams(window.location.search);
    let pageLevel;
    if (urlParams.size !== 0) {
        pageLevel = urlParams.get("level");
        if (pageLevel === null) pageLevel = "1";
    } else pageLevel = "1";
    if (pageLevel === "2") $058373812b4fba5d$var$renderPageLevelTwo();
    if (pageLevel === "1") $058373812b4fba5d$var$renderPageLevelOne();
    $058373812b4fba5d$var$backSectionNavigation();
    $058373812b4fba5d$var$sideBar.querySelectorAll(".sidebar__wrapper .sidebar-item__wrapper a").forEach((sidebarItemLink)=>{
        sidebarItemLink.addEventListener("click", (event)=>$058373812b4fba5d$var$activateMobileSidebarItem(event, sidebarItemLink));
    });
}
function $058373812b4fba5d$var$activateMobileSidebarItem(event, sidebarItemLink) {
    event.preventDefault();
    const sidebarItem = sidebarItemLink.closest(".sidebar-item__wrapper");
    if (!sidebarItem) return;
    let sidebarHref = sidebarItemLink.getAttribute("href");
    if (!sidebarHref || sidebarHref === "") return;
    let sidebarItemClasses = sidebarItem.classList;
    if (sidebarItemClasses.length === 0) return;
    sidebarItemClasses = Array.from(sidebarItemClasses);
    const isSlidebarPageCurrentlyActive = sidebarItemClasses.includes("selected");
    if (isSlidebarPageCurrentlyActive) $058373812b4fba5d$var$renderPageLevelTwo();
    else {
        let sidebarHrefIncludesViewQueryParam = sidebarHref.includes("?view");
        let sidebarHrefModified = "";
        if (sidebarHrefIncludesViewQueryParam) sidebarHrefModified = sidebarHref + "&level=2";
        else sidebarHrefModified = sidebarHref + "?level=2";
        location.href = sidebarHrefModified;
    }
}
function $058373812b4fba5d$var$renderPageLevelTwo() {
    const pageLayout = document.querySelector(".PageLayout--klub");
    $058373812b4fba5d$var$sideBar.classList.add("d-none", "d-xl-block");
    if (!pageLayout || !$058373812b4fba5d$var$pageLayoutMain) return;
    if ($058373812b4fba5d$var$pageLayoutMain.classList.contains("d-none") && $058373812b4fba5d$var$pageLayoutMain.classList.contains("d-xl-block")) {
        $058373812b4fba5d$var$pageLayoutMain.classList.remove("d-none");
        $058373812b4fba5d$var$pageLayoutMain.classList.remove("d-xl-block");
    }
    $058373812b4fba5d$var$backSectionNavigation();
}
function $058373812b4fba5d$var$renderPageLevelOne() {
    const pageLayout = document.querySelector(".PageLayout--klub");
    if (!pageLayout || !$058373812b4fba5d$var$pageLayoutMain) return;
    $058373812b4fba5d$var$sideBar.classList.remove("d-none", "d-xl-block");
    if (!$058373812b4fba5d$var$pageLayoutMain.classList.contains("d-none") && !$058373812b4fba5d$var$pageLayoutMain.classList.contains("d-xl-block")) $058373812b4fba5d$var$pageLayoutMain.classList.add("d-none", "d-xl-block");
}
function $058373812b4fba5d$var$backSectionNavigation() {
    const backSectionNavigations = document.querySelectorAll(".back-section__wrapper");
    backSectionNavigations.forEach((backSectionNavigation)=>{
        backSectionNavigation.addEventListener("click", ()=>$058373812b4fba5d$var$renderPageLevelOne());
    });
}
function $058373812b4fba5d$var$debounce(func, delay) {
    let timeoutId;
    return function(...args) {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            func.apply(this, args);
        }, delay);
    };
}
let $058373812b4fba5d$var$lastWidth = window.innerWidth;
function $058373812b4fba5d$var$handleResize() {
    let screenWidth = window.innerWidth;
    if ($058373812b4fba5d$var$sideBar && screenWidth < 1300) $058373812b4fba5d$var$mobileSidebar();
}
function $058373812b4fba5d$var$checkResize() {
    const currentWidth = window.innerWidth;
    if (Math.abs(currentWidth - $058373812b4fba5d$var$lastWidth) >= 10) {
        $058373812b4fba5d$var$lastWidth = currentWidth;
        $058373812b4fba5d$var$handleResize();
    }
}
const $058373812b4fba5d$var$debouncedCheckResize = $058373812b4fba5d$var$debounce($058373812b4fba5d$var$checkResize, 200);
window.addEventListener("resize", $058373812b4fba5d$var$debouncedCheckResize);





})();
//# sourceMappingURL=parcel_scripts.js.map
